// 学院专业
<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="10">
        <h3>学院</h3>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-row :gutter="20">
              <el-col :span="18">
                <el-input
                  size="small"
                  placeholder="请输入学院名称"
                  v-model="searchObj.collegeName"
                  clearable
                >
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-button
                  size="mini"
                  style="float: right"
                  type="primary"
                  @click="getCollegeList"
                  >搜索</el-button
                >
              </el-col>
            </el-row>
            <el-button
              size="medium"
              plain
              style="width: 100%; margin-top: 0.1rem"
              type="primary"
              @click="college = true"
              >+ 添加</el-button
            >
          </div>
          <div
            class="scroll"
            style="overflow-y: auto; height: 3rem; padding-right: 25px"
          >
            <div
              v-for="(v, i) in collegeList"
              :key="i"
              @click="selectCollege(i)"
              class="text item"
              :class="{ selectCollege: isSelect == i }"
            >
              <div
                style="
                  display: flex;
                  line-height: 2;
                  justify-content: space-between;
                  padding: 0.1rem 0.05rem;
                "
              >
                <div>
                  <span v-if="collegeIndex != i">{{ v.name }}</span>
                  <i
                    @click="collegeIndex = i"
                    v-if="collegeIndex != i"
                    class="el-icon-edit"
                  ></i>
                  <el-input
                    v-else
                    size="mini"
                    placeholder="请输入学院名称"
                    v-model="collegeList[collegeIndex].name"
                    clearable
                  ></el-input>
                </div>
                <div>
                  <i
                    @click="deleteCollege(i)"
                    v-if="collegeIndex != i"
                    class="el-icon-close"
                  ></i>
                  <i
                    style="line-height: 1.5"
                    @click="editCollege"
                    v-else
                    class="el-icon-check"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="14">
        <h3>专业</h3>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-row :gutter="20">
              <el-col :span="20">
                <el-input
                  size="small"
                  placeholder="请输入专业名称"
                  v-model="searchObj.majorName"
                  clearable
                >
                </el-input>
              </el-col>
              <el-col :span="4">
                <el-button
                  size="mini"
                  style="float: right"
                  type="primary"
                  @click="getMajorList"
                  >搜索</el-button
                >
              </el-col>
            </el-row>
            <el-button
              size="medium"
              plain
              style="width: 100%; margin-top: 0.1rem"
              type="primary"
              @click="major = true"
              >+ 添加</el-button
            >
          </div>
          <div
            class="scroll"
            style="overflow-y: auto; height: 3rem; padding-right: 25px"
          >
            <div v-for="(v, i) in majorList" :key="i" class="text item">
              <div
                style="
                  display: flex;
                  line-height: 2;
                  justify-content: space-between;
                  padding: 0.1rem 0.05rem;
                "
              >
                <div>
                  <span v-if="majorIndex != i">{{ v.name }}</span>
                  <i
                    @click="majorIndex = i"
                    v-if="majorIndex != i"
                    class="el-icon-edit"
                  ></i>
                  <el-input
                    v-else
                    size="mini"
                    placeholder="请输入学院名称"
                    v-model="majorList[majorIndex].name"
                    clearable
                  ></el-input>
                </div>
                <div>
                  <i
                    @click="deleteMajor(i)"
                    v-if="majorIndex != i"
                    class="el-icon-close"
                  ></i>
                  <i
                    style="line-height: 1.5"
                    @click="editMajor"
                    v-else
                    class="el-icon-check"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      width="20%"
      title="添加"
      :visible.sync="college"
      append-to-body
      @close="close"
    >
      <el-input
        size="small"
        placeholder="请输入学院名称"
        v-model="addCollegeInfo.name"
        clearable
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCollege()">添加</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="20%"
      title="添加"
      :visible.sync="major"
      append-to-body
      @close="close"
    >
      <el-input
        size="small"
        placeholder="请输入专业名称"
        v-model="addMajorInfo.name"
        clearable
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMajor()">添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    schoolId: {},
  },
  watch: {
    //深度监听（解决了值刷新不及时的问题）
    schoolId: {
      handler: function (newval, oldVal) {
        this.currId = newval;
        this.getCollegeList();
        this.getMajorList();
      },
      immediate: true,
    },
  },
  data() {
    return {
      currId: "",
      shoolTxt: "",
      collegeIndex: -1,
      college: false,
      collegeTxt: "",
      collegeList: [],
      majorList: [],
      majorIndex: -1,
      major: false,
      addcollegeTxt: "",
      //搜索
      searchObj: {
        collegeName: "",
        majorName: "",
      },
      //添加学院信息
      addCollegeInfo: {
        name: "",
      },
      //添加专业
      addMajorInfo: {
        name: "",
      },
      //选择学院
      isSelect: 0,
    };
  },
  created() {
    this.getCollegeList();
    this.currId = this.schoolId;
  },
  mounted() {},
  methods: {
    addCollege2() {
      this.collegeList.push(this.addcollegeTxt);
      this.addcollegeTxt = "";
      this.college = false;
    },
    close() {
      this.addCollegeInfo.name = "";
      this.addMajorInfo.name = "";
    },
    //获取学院列表
    getCollegeList() {
      this.$api
        .get(
          "/admin/School/GetCollegeList?schoolid=" +
            this.currId +
            "&name=" +
            this.searchObj.collegeName
        )
        .then((res) => {
          if (res.succeed) {
            this.collegeList = res.data;
            this.getMajorList();
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //获取专业列表
    getMajorList() {
      this.$api
        .get(
          "/admin/School/GetMajorList?schoolid=" +
            this.currId +
            "&collegeid=" +
            this.collegeList[this.isSelect].id +
            "&name=" +
            this.searchObj.majorName
        )
        .then((res) => {
          if (res.succeed) {
            this.majorList = res.data;
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //添加学院
    addCollege() {
      if (this.$dataConver.isNull(this.addCollegeInfo.name)) {
        this.$message.error("请输入学院名称！");
        return false;
      }
      this.$api
        .post("/admin/School/AddCollege", {
          name: this.addCollegeInfo.name,
          schoolId: this.currId,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.college = false;
            this.close();
            this.getCollegeList();
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //编辑学院
    editCollege() {
      if (this.$dataConver.isNull(this.collegeList[this.collegeIndex].name)) {
        this.$message.error("请输入学院名称！");
        return false;
      }
      this.$api
        .get(
          "/admin/School/EditCollege?id=" +
            this.collegeList[this.collegeIndex].id +
            "&name=" +
            this.collegeList[this.collegeIndex].name
        )
        .then((res) => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.collegeIndex = -1;
            this.getCollegeList();
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //删除学院
    deleteCollege(index) {
      this.$confirm("确认删除此学院吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.majorList.length > 0) {
            this.$message.error("此学院下有专业，不能删除！");
            return false;
          }
          this.$api
            .get("/admin/School/DeleteCollege?id=" + this.collegeList[index].id)
            .then((res) => {
              if (res.succeed) {
                this.$message.success("操作成功！");
                this.getCollegeList();
              } else {
                this.$message.error(res.error);
              }
            });
        })
        .catch(() => {});
    },
    //添加专业
    addMajor() {
      if (this.$dataConver.isNull(this.addMajorInfo.name)) {
        this.$message.error("请输入专业名称！");
        return false;
      }
      this.$api
        .post("/admin/School/AddMajor", {
          name: this.addMajorInfo.name,
          schoolId: this.currId,
          collegeId: this.collegeList[this.isSelect].id,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.major = false;
            this.close();
            this.getMajorList();
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //编辑专业
    editMajor() {
      if (this.$dataConver.isNull(this.majorList[this.majorIndex].name)) {
        this.$message.error("请输入专业名称！");
        return false;
      }
      this.$api
        .post("/admin/School/EditMajor", {
          id: this.majorList[this.majorIndex].id,
          name: this.majorList[this.majorIndex].name,
          schoolId: this.currId,
          collegeId: this.collegeList[this.isSelect].id,
          creationTime: "2022-07-28T02:58:44.149Z",
          isDeleted: true,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.majorIndex = -1;
            this.getMajorList();
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //删除专业
    deleteMajor(index) {
      this.$confirm("确认删除此专业吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .get("/admin/School/DeleteMajor?id=" + this.majorList[index].id)
            .then((res) => {
              if (res.succeed) {
                this.$message.success("操作成功！");
                this.getMajorList();
              } else {
                this.$message.error(res.error);
              }
            });
        })
        .catch(() => {});
    },
    //选择学院
    selectCollege(i) {
      this.isSelect = i;
      this.getMajorList();
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  cursor: pointer;
}
.selectCollege {
  background-color: #409eff;
  color: #fff;
}
h3 {
  font-size: 0.24rem;
  line-height: 2;
}

i {
  font-size: 0.16rem;
  cursor: pointer;
}
.selectCollege {
  .el-icon-check,
  .el-icon-close,
  .el-icon-edit {
    color: #fff;
  }
  .el-icon-check:hover,
  .el-icon-close:hover,
  .el-icon-edit:hover {
    color: #fff;
  }
}

.el-icon-edit:hover {
  color: #409eff;
}

.el-icon-close:hover {
  color: #f00;
}

.el-icon-check:hover {
  color: #55d355;
}
.scroll::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 5px;
  height: 5px;
}

/*.scroll::-webkit-scrollbar-button{!*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*!*/
/*background:#fff;*/
/*}*/
.scroll::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  background: #f8f9fa;
}

.scroll::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  background: #f8f9fa;
}

.scroll::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #00000033;
  border-radius: 4px;
}

.scroll::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #eee;
}

/*#scroll::-webkit-scrollbar-resizer  {!*定义右下角拖动块的样式（位置7）*!*/
/*background:#FF0BEE;*/
/*}*/
.scroll {
  scrollbar-arrow-color: #f4ae21;
  /**/
  /*三角箭头的颜色*/
  scrollbar-face-color: #333;
  /**/
  /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666;
  /**/
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666;
  /**/
  /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999;
  /**/
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666;
  /**/
  /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666;
  /**/
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8;
  /**/
  /*滚动条的基本颜色*/
}
</style>


// WEBPACK FOOTER //
// src/components/collegeMajor.vue